<template>
  <div class="main_center">
    <div class="content">
      <div class="search-content">
        <div class="mainBtn">

        </div>
        <div class="searchBtn">
          <span class="label-form">关键字搜索：</span>
          <el-input @keyup.enter.native="getDataList" clearable placeholder="项目名称/举报内容" style="width: 200px" v-model="dataForm.searchKey"></el-input>
          <el-button @click="getDataList" size="small" style="margin-left: 12px" type="primary">搜索</el-button>
          <el-divider direction="vertical"></el-divider>
          <el-button @click="refresh" icon="el-icon-refresh" type="text"></el-button>
        </div>
      </div>
      <el-table
        :data="dataList"
        :header-cell-style="this.$globalGrayTableHeaderStyle"
        @selection-change="selectionChangeHandle"
        :height="tableMaxHeight"
        border
        stripe
        class="table-content"
        v-loading="dataListLoading">
        <el-table-column
          :index="getRowsIndex"
          align="center"
          fixed
          header-align="center"
          label="序号"
          type="index"
          width="60"
        >
        </el-table-column>
        <el-table-column
                align="center"
                label="项目类型"
                prop="tradeTypeName"
                width="100">
        </el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          align="left"
          label="项目名称"
          prop="projectName">
        </el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          align="left"
          label="举报内容"
          prop="contentText">
        </el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          align="left"
          label="举报人"
          prop="userName"
          width="200">
        </el-table-column>
        <el-table-column
                align="center"
                header-align="center"
                label="举报方式"
                prop="reportWayName"
                width="120">
        </el-table-column>
        <el-table-column
          align="center"
          header-align="center"
          label="手机号码"
          prop="userPhone"
          width="130">
        </el-table-column>
        <el-table-column
          align="center"
          header-align="center"
          label="提交时间"
          prop="reportTime"
          width="160">
        </el-table-column>
        <el-table-column
          align="center"
          fixed="right"
          header-align="center"
          label="操作"
          width="100">
          <template slot-scope="scope">
            <el-button @click="viewHandle(scope.row.id)" size="small" type="text">查看</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        :current-page="pageIndex"
        :page-size="pageSize"
        :page-sizes="[10, 20, 50, 100]"
        :total="totalPage"
        @current-change="currentChangeHandle"
        @size-change="sizeChangeHandle"
        layout="total, sizes, prev, pager, next, jumper">
      </el-pagination>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
  export default {
    props: ['mainContentViewHeight'],
    data () {
      return {
        dataForm: {
          searchKey: '',
          tradeId:'',
        },
        dataList: [],
        tableMaxHeight: document.documentElement.clientHeight - 227 ,
        pageIndex: 1,
        pageSize: 10,
        totalPage: 0,
        dataListLoading: false,
        dataListSelections: []
      }
    },
    components: {
      // AddOrUpdate
    },
    activated () {
      this.getDataList()
    },

  computed:{
		...mapState({
        isAdmin: state => {return state.user.userinfo.selectRoleCode == "ADMIN"}
    }),
	},
    mounted() {
      const that = this;
      let resizeTag = true;
      window.onresize = () => {
        if(resizeTag) { //防抖动
          that.ifmove();
          resizeTag = false
          setTimeout(() => {
            resizeTag = true
          }, 1000)
        }
      }
      that.ifmove();
    },
    methods: {
      ifmove() {
        // let hasBtnPermisson = this.hasBtnPermission('');
        let tableMaxHeight = document.documentElement.clientHeight - 227 ;
        this.pageSize = parseInt((tableMaxHeight) / 50 ) || 1;
        this.$nextTick(() => {
          this.tableMaxHeight = tableMaxHeight
        })
      },
      refresh() {
        this.pageIndex = 1;
        this.dataForm.searchKey = '';
        this.dataForm.tradeId = '';
        this.getDataList()
      },

      // 获取数据列表
      getDataList () {
        this.dataListLoading = true
        this.$httpReq.post( '/complaint_reporting/list',{
          'page': this.pageIndex,
          'rows': this.pageSize,
          'searchKey':this.dataForm.searchKey,
          'filter':this.dataForm
        }).then(({data}) => {
          if (data ) {
            this.dataList = data.rows
            this.totalPage = data.totalItemCount
          } else {
            this.dataList = []
            this.totalPage = 0
          }
          this.dataListLoading = false
        })
      },

      getRowsIndex(index) {
        return (this.pageIndex - 1) * this.pageSize + index + 1
      },
      // 每页数
      sizeChangeHandle (val) {
        this.pageSize = val
        this.pageIndex = 1
        this.getDataList()
      },
      // 当前页
      currentChangeHandle (val) {
        this.pageIndex = val
        this.getDataList()
      },
      // 多选
      selectionChangeHandle (val) {
        this.dataListSelections = val
      },
      // 查看
      viewHandle (id) {
        let route_name = "complaint_reporting_view";
        this.$router.push({
          name:route_name,
          query:{
            id : id,
          }
        })
      },
      // 删除
      deleteHandle (id) {
        this.$confirm(`确定要删除该数据?`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$httpReq.post('/complaint_reporting/delete',{id:id}).then(({data}) => {
            if (data && data.code === '1') {
              this.$message({
                message: '操作成功',
                type: 'success',
                duration: 1500,
                onClose: () => {
                  this.getDataList()
                }
              })
            } else {
              this.$message.error(data.msg)
            }
          })
        }).catch(() => {})
      }
    }
  }
</script>
<style lang="scss" scoped>

  //列表页面
  .main-content{
    .switch-text{
      font-size: 12px;
      position: absolute;
      color: rgba(255, 255, 255, 1);
      line-height: 26px;
    }
    .switch-active{
      left:7px;
    }
    .switch-inactive{
      right:7px;
    }

  }

</style>